import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUser = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M19 20V19C19 16.7909 17.2091 15 15 15H9C6.79086 15 5 16.7909 5 19V20",
		stroke: "currentColor",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("circle", {
		cx: 12,
		cy: 8,
		r: 4,
		stroke: "currentColor",
		strokeWidth: 1.5
	})]
});
export default SvgUser;
